import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'sku.mobileActionSheet.cancel',
    defaultMessage: 'Cancel',
  },
});
